/* eslint-disable prettier/prettier */
import { AjaxError } from "rxjs/ajax";

export const IsErrorApi = (err: unknown) => {
  return (
    ((err as AjaxError).status || (err as AjaxError).status === 0) &&
    ((err as AjaxError).status < 200 || (err as AjaxError).status > 299)
  );
};